<template>
  <section class="ps-table-wrap">
      <!-- scroll-width="187rem" -->
    <ve-table
      :fixed-header="true"
      max-height="calc(100vh - 11.4rem)"
      :columns="columns"
      :table-data="tableData"
      :border-around="false"

    />

    <empty-state
      v-if="!isLoading && isEmpty"
      title="There are no available records"
    />
    <div v-if="isLoading" class="contacts--loader">
      <spinner />
      <span>{{ $t('FLOW.LOADING') }}</span>
    </div>
    <!-- pagination -->
  </section>
</template>


<script>
import { mixin as clickaway } from 'vue-clickaway';
import { VeTable } from 'vue-easytable';

import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import timeMixin from 'dashboard/mixins/time';

export default {
    components: {
        EmptyState,
        Spinner,
        VeTable,
    },
    mixins: [clickaway, timeMixin],
    props: {
        data: {
            type: Array,
            default: () => null,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        isEmpty(){
          return !this.tableData.length
        },
        tableData() {
            // if (this.isLoading) {
            //     return [];
            // }
            if (Array.isArray(this.data)) {
                return this.data;
            }
            return [];
        },
        columns() {
            return [
                {
                    field: 'id',
                    key: 'id',
                    title: 'Transaction ID',
                    align: 'left',
                    // fixed: 'left',
                    width: 180,
                },
                {
                    field: 'type',
                    key: 'type',
                    title: 'Type',
                    align: 'center',
                    width: 120,
                },
                {
                    field: 'amount',
                    key: 'amount',
                    title: 'Amount (USD)',
                    align: 'right',
                    width: 150,
                  renderBodyCell: ({row})=>{
                    const sign = row.kind === 'refund' ? "- " : "";
                    return `${sign}${row.amount}`
                  }
                },
                {
                    field: 'completed',
                    key: 'completed',
                    title: 'Completed',
                    align: 'center',
                    width: 100,
                    renderBodyCell: ({row})=>{
                        return <span>{row.completed ? "Yes" : "No"}</span>
                    }
                },
                {
                    field: 'kind',
                    key: 'kind',
                    title: 'Kind',
                    align: 'left',
                    width: 120,
                },
                {
                    field: 'created_at',
                    key: 'created_at',
                    title: 'Created At',
                    align: 'left',
                    width: 210,
                    renderBodyCell: ({row})=>{
                        try {
                            const date = new Date(row.created_at);
                            const formattedDate = new Intl.DateTimeFormat('en-US', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true,
                            }).format(date);
                            return <span>{formattedDate}</span>
                        } catch (error) {
                            return <span></span>
                        }
                    }
                },

            ];
        },
        // end computed
    },
    mounted() {},
    methods: {},
}
</script>



<style lang="scss" scoped>
@import '~dashboard/assets/scss/mixins';
@import '~dashboard/assets/scss/widgets/_ps_table.scss';

.contacts--loader {
  align-items: center;
  display: flex;
  font-size: var(--font-size-default);
  justify-content: center;
  padding: var(--space-big);
}

.cell--social-profiles {
  a {
    color: var(--s-300);
    display: inline-block;
    font-size: var(--font-size-medium);
    min-width: var(--space-large);
    text-align: center;
  }
}
</style>
